<script setup>

defineProps({
  item: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <a :href="item.url"
     class="flex rounded-lg bg-white hover:bg-gray-100 transition-colors duration-150 ease-in-out shadow-md group gap-2"
  >
    <img
      :src="item.image"
      :alt="item.name"
      class="object-cover size-20 md:size-24 rounded-l-lg"
    >
    <div class="flex flex-col min-w-0 max-w-full justify-around py-2 pr-3">
      <div class="space-y-1">
        <h3 class="text-sm text-blue-600 visited:text-purple-800 sm:text-base group-hover:underline">
          {{ item.name }}
        </h3>
        <p class="truncate pr-5 text-sm">
          {{ item.description }}
        </p>
        <p class="text-xs font-medium text-gray-500">
          {{ __(':count Articles', { count: item.counter }) }}
        </p>
      </div>
    </div>
  </a>
</template>
